import { render, staticRenderFns } from "./svg-icons.vue?vue&type=template&id=e8d1407e&"
import script from "./svg-icons.vue?vue&type=script&lang=js&"
export * from "./svg-icons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports